import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { useSelector, useDispatch } from 'react-redux';
import { Input, Button, Modal } from 'antd';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';

import styles from './styles';
import { login } from '../Actions';
import { successNotification, errorNotification } from '../Snackbar';
import Api from '../Api';
import GetField from '../Components/GetField';

const AntInput = GetField(Input);
const AntPassword = GetField(Input.Password);

const Login = props => {
  const { classes } = props;
  const dispatch = useDispatch();
  const history = useHistory();

  const { handleSubmit, control, getValues } = useForm();

  const [visibleForgotEmail, setVisibleForgotEmail] = useState(false);
  const [visibleForgotPassword, setVisibleForgotPassword] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [visibleVerifyModal, setVisibleVerifyModal] = useState(false);

  const auth = useSelector(state => state.auth);

  useEffect(() => {
    if (auth.type && auth.user) {
      history.push('/');
    }
  }, [auth]);

  const onSubmit = async formValues => {
    try {
      await dispatch(login(formValues)).then(() => {
        history.push('/');
      });
    } catch (err) {
      errorNotification(err);
    }
  };

  const hideForgotModal = () => {
    setVisibleForgotEmail(false);
    setVisibleForgotPassword(false);
    setConfirmLoading(false);
  };

  const showForgotModal = () => {
    setVisibleForgotEmail(true);
  };

  const onForgot = async () => {
    try {
      const formValues = getValues();

      if (!formValues || !formValues.email) {
        return errorNotification({ message: 'Email is required' });
      }

      const { email } = formValues;

      setConfirmLoading(true);
      await Api.post('/auth/forget', { email });
      successNotification('Code sent to entered your e-mail');
      setVisibleForgotEmail(false);
      setConfirmLoading(false);
      setVisibleForgotPassword(true);
    } catch (err) {
      setConfirmLoading(false);
      errorNotification(err);
    }
  };

  const onSubmitNewPasword = async () => {
    try {
      const formValues = getValues();

      if (!formValues || !formValues.password) {
        return errorNotification({ message: 'New password is required' });
      }

      const { email, otp, password, repeatPassword } = formValues;

      if (!repeatPassword) {
        return errorNotification({ message: 'Repeat password is required' });
      }

      if (password !== repeatPassword) {
        return errorNotification({ message: "Password doesn't match" });
      }

      await Api.post('/auth/set', { email, otp, password });
      successNotification('Password changed');
      hideForgotModal();
    } catch (err) {
      setConfirmLoading(false);
      errorNotification(err);
    }
  };

  const getTitle = () => {
    if (visibleForgotEmail) {
      return 'Forgot password ? 1/2';
    }

    if (visibleForgotPassword) {
      return 'Forgot password ? 2/2';
    }
  };

  const getCallback = () => {
    if (visibleForgotEmail) {
      return onForgot;
    }

    if (visibleForgotPassword) {
      return onSubmitNewPasword;
    }

    return () => {};
  };

  const showVerifyModal = () => {
    setVisibleVerifyModal(true);
  };

  const hideVefiryModal = () => {
    setVisibleVerifyModal(false);
  };

  const handleVefiryModalOk = async () => {
    try {
      const formValues = getValues();
      const { email, otp, password, repeatPassword } = formValues;
      if (!formValues || !formValues.email) {
        return errorNotification({ message: 'Email is required' });
      }

      if (!formValues || !formValues.otp) {
        return errorNotification({ message: 'Code is required' });
      }

      if (!formValues || !formValues.password) {
        return errorNotification({ message: 'Password is required' });
      }

      if (!repeatPassword) {
        return errorNotification({ message: 'Repeat Password is required' });
      }

      if (password !== repeatPassword) {
        return errorNotification({ message: "Passwords doesn't match" });
      }

      await Api.post('/auth/set', { email, otp, password });
      successNotification('Password set sucessfully');
      hideVefiryModal();
    } catch (err) {
      setVisibleVerifyModal(false);
      errorNotification(err);
    }
  };

  return (
    <div className={classes.loginBackground}>
      <div className={classes.loginBox}>
        <span className={classes.companyName}>
          Sign in to Renuka Home Private Limited
        </span>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <AntInput required allowClear placeholder="Email" {...field} />
            )}
          />
          <Controller
            name="password"
            control={control}
            render={({ field }) => (
              <AntPassword
                required
                allowClear
                placeholder="Password"
                {...field}
              />
            )}
          />
          <Button
            className={classes.signInButton}
            type="primary"
            htmlType="submit"
          >
            Sign in
          </Button>
          <div className={classes.linkStyle}>
            <Link
              to="/login"
              onKeyPress={showForgotModal}
              onClick={showForgotModal}
            >
              Forgot password ?
            </Link>
            <Link
              to="/login"
              onKeyPress={showVerifyModal}
              onClick={showVerifyModal}
            >
              Verify
            </Link>
          </div>
        </form>
        <Modal
          onOk={getCallback()}
          visible={visibleForgotEmail || visibleForgotPassword}
          confirmLoading={confirmLoading}
          onCancel={hideForgotModal}
          centered
          maskClosable={false}
          title={getTitle()}
          width="30%"
          cancelText="Back"
          okText="Continue"
        >
          <>
            {visibleForgotEmail ? (
              <>
                <p>
                  You will receive 6 digits characters code by e-mail to verify
                  your identity.
                </p>
                <Controller
                  name="email"
                  control={control}
                  render={({ field }) => (
                    <AntInput
                      allowClear
                      placeholder="Email to recover"
                      {...field}
                    />
                  )}
                />
              </>
            ) : null}
            {visibleForgotPassword ? (
              <>
                <p>
                  You have received a six digits characters code by e-mail{' '}
                  <span>📫</span>. Enter it in the Code, Password and Repeat
                  Password fields below to continue.
                </p>
                <Controller
                  name="otp"
                  control={control}
                  render={({ field }) => (
                    <AntInput allowClear placeholder="Code" {...field} />
                  )}
                />
                <Controller
                  name="password"
                  control={control}
                  render={({ field }) => (
                    <AntPassword
                      required
                      allowClear
                      placeholder="Password"
                      {...field}
                    />
                  )}
                />
                <Controller
                  name="repeatPassword"
                  control={control}
                  render={({ field }) => (
                    <AntPassword
                      required
                      allowClear
                      placeholder="Repeat Password"
                      {...field}
                    />
                  )}
                />
              </>
            ) : null}
          </>
        </Modal>
        <Modal
          onOk={handleVefiryModalOk}
          visible={visibleVerifyModal}
          onCancel={hideVefiryModal}
          centered
          maskClosable={false}
          title="Verify and set password"
          width="30%"
          cancelText="Back"
          okText="Submit"
        >
          <p>
            Enter the e-mail and code (You have received a six digits characters
            code by e-mail <span>📫</span> ), plus new password in Password and
            Repeat Password fields below to continue.
          </p>
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <AntInput allowClear placeholder="Email" {...field} />
            )}
          />
          <Controller
            name="otp"
            control={control}
            render={({ field }) => (
              <AntInput allowClear placeholder="Code" {...field} />
            )}
          />
          <Controller
            name="password"
            control={control}
            render={({ field }) => (
              <AntPassword
                required
                allowClear
                placeholder="Password"
                {...field}
              />
            )}
          />
          <Controller
            name="repeatPassword"
            control={control}
            render={({ field }) => (
              <AntPassword
                required
                allowClear
                placeholder="Repeat Password"
                {...field}
              />
            )}
          />
        </Modal>
      </div>
    </div>
  );
};

Login.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Login);
